export interface FullTourIntroProps {
  onSkip: () => void
  onStart: () => void
}
